import React, { useState, useEffect, useContext } from 'react';
import { GlobalContext } from '../../../Context/GlobalContext';
import Grid from '@material-ui/core/Grid';
import PurchasedContentCard from './PurchasedContentCard';
import axios from 'axios';

const PurchasedContentPage = () => {
  const { viewerObj } = useContext(GlobalContext);

  const [paidDownloads, setPaidDownloads] = useState([]);
  const [paidVideos, setPaidVideos] = useState([]);

  // when the viewerObj is mounted retrieve the users purchased content
  useEffect(() =>{ 
    if (viewerObj) {
      (async () => {
        const { data } = await axios.post('https://h4e7hrnswg.execute-api.us-west-2.amazonaws.com/default/get-purchased-content',{ 
          paidVideosIds: viewerObj.paidVideos,
          paidDownloadsIds: viewerObj.paidDownloads
        });

        setPaidDownloads(data.paidDownloads);
        setPaidVideos(data.paidVideos);
      })()
    }
  },[viewerObj])

  return (
    <Grid 
      container 
      item
      justifyContent="space-between"
      spacing={6}
    >
      
       {
        paidVideos.map(video => 
        (
          <Grid item key={video._id} lg={4}  >
            <PurchasedContentCard video={video} />
          </Grid>
        ))
       }

       {
        paidDownloads.map((video, i) => 
        (
          <Grid item key={i} lg={4}  >
            <PurchasedContentCard video={video} />
          </Grid>
        ))
       }
    </Grid>
  )

  
}

export default PurchasedContentPage